// eslint-disable-next-line
export const TOGGLE_LOADING = 'loading/toggle-loading';
